// @flow

import * as React from 'react';

import Box from 'sail/Box';
import {Text} from 'sail/Text';
import {UnstyledLink} from 'sail/UnstyledLink';
import Icon from 'sail/Icon';

import './MenuButton.scss';

type MenuButtonProps = {|
  href?: ?string,
  isActive?: boolean,
  isBackIconVisible?: boolean,
  isRightArrowVisible?: boolean,
  label: string,
  onClick?: () => void,
|};

export const MenuButton = ({
  href,
  isActive,
  isBackIconVisible,
  isRightArrowVisible,
  label,
  onClick,
}: MenuButtonProps) => {
  const textColor = isActive ? 'blue500' : 'gray900';
  return (
    <UnstyledLink className="MenuButton" href={href} onClick={onClick}>
      <Box
        flex={{alignItems: 'center', justifyContent: 'space-between'}}
        margin={{right: 12}}
      >
        <Box flex={{alignItems: 'center'}}>
          {isBackIconVisible ? (
            <Box margin={{right: 16}}>
              <Icon size={12} icon="chevronLeft" />
            </Box>
          ) : null}
          <Box>
            <Text color={textColor} size={16}>
              {label}
            </Text>
          </Box>
        </Box>
        {isRightArrowVisible ? <Icon size={12} icon="chevronRight" /> : null}
      </Box>
    </UnstyledLink>
  );
};

type BackButtonProps = {|
  label: string,
  onClick: () => void,
|};

export const BackButton = ({label, onClick}: BackButtonProps) => {
  return (
    <MenuButton
      label={label}
      isRightArrowVisible={false}
      onClick={onClick}
      isBackIconVisible
    />
  );
};
